<form [formGroup]="formDadosColaborador" (ngSubmit)="submitForm(formDadosColaborador)">
    <div class="card-content">
        <div class="card-holder --newBrand">
            <p class="card-holder-label" data-test="editLabelEmail">E-mail:</p>
            <p class="card-holder-input"><input data-test="editValueEmail" class="input-edit --dark" formControlName="email"></p>
        </div>
        <div class="card-holder --newBrand" formGroupName="phone_number">
            <p class="card-holder-label" data-test="editLabelPhone">Celular:</p>
            <p class="card-holder-input"><input data-test="editValuePhone" class="input-edit --dark" [textMask]="{mask: phoneMask}" formControlName="number"></p>
        </div>
    </div>
    <div class="card-footer">
        <button class="button-default button-link" type="button" data-test="btnCancelInfosCont" (click)="cancel($event)">Cancelar</button>
        <button class="button-default button-confirm" data-test="btnSalveInfosCont" type="submit" [disabled]="this.submittingForm">Salvar</button>
    </div>
</form>
